/** Проверяет попадание точки в многоугольник, включая его границу. Координаты должны быть в одной проекции. */
export function isPointInPolygon(point, polygon) {
  if (polygon.length < 3) return false;
  const epsilon = 1e-12;
  const cross = (a, b, c) => (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x);
  const secondPoint = polygon.find(vertex => Math.abs(vertex.x - polygon[0].x) > epsilon || Math.abs(vertex.y - polygon[0].y) > epsilon);
  if (!secondPoint || !polygon.some(vertex => Math.abs(cross(polygon[0], secondPoint, vertex)) > epsilon)) return false;

  let inside = false;
  for (let index = 0, previous = polygon.length - 1; index < polygon.length; previous = index++) {
    const a = polygon[previous], b = polygon[index];
    if (Math.abs(cross(a, b, point)) <= epsilon
      && point.x >= Math.min(a.x, b.x) - epsilon && point.x <= Math.max(a.x, b.x) + epsilon
      && point.y >= Math.min(a.y, b.y) - epsilon && point.y <= Math.max(a.y, b.y) + epsilon) return true;
    if ((a.y > point.y) !== (b.y > point.y)
      && point.x < (b.x - a.x) * (point.y - a.y) / (b.y - a.y) + a.x) {
      inside = !inside;
    }
  }
  return inside;
}
